import { colorBlock } from '../defaultSpacing';

export default {
    data: function() {
        let config = {
            fullColumn: false,
            ...colorBlock,
            title: '',
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            button: {
                text: '',
                color: ''
            }
        };
        return {
            ...config,
            listingDetail: '' // used as subtitle
        };
    },
    methods: {
        goTour() {
            let module = this.$root.getModuleByName('md-detail-info');
            if (module && module.scrollIntoSchedule) {
                module.scrollIntoSchedule();
            }
        }
    },
    computed: {
        suitableImg() {
            if (this.isMobileSize && this.bgImgOpt.mobileSrc) {
                return this.bgImgOpt.mobileSrc; 
            }
            return this.bgImgOpt.src || this.bgImgOpt.mobileSrc;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
    created() {
        this.listingDetail = this.listingDetail || {};
    }
};
